import { TDatabase } from '../../types/types';
import redshiftIcon from '../../assets/Database/redshiftIcon.png';
import databricksIcon from '../../assets/Database/databricksIcon.png';
import mssqlicon from '../../assets/Database/mssqlicon.png';
import mysqlicon from '../../assets/Database/mysqlicon.svg';
import postgresicon from '../../assets/Database/postgresicon.png';
import bigqueryicon from '../../assets/Database/bigqueryicon.svg';
import oracleicon from '../../assets/Database/oracleicon.svg';
import snowflakeicon from '../../assets/Database/snowflakeicon.svg';
import motherduckicon from '../../assets/Database/motherduckicon.png';
import ibmdb2icon from '../../assets/Database/ibmdb2icon.png';
import teradataicon from '../../assets/Database/teradataicon.png';
import athenaicon from '../../assets/Database/athenaicon.png';
import mariadbicon from '../../assets/Database/mariadbicon.png';
import saphanaicon from '../../assets/Database/saphana.webp';
import clickhouseicon from '../../assets/Database/clickhouse.png';

export const requiredFields: {
  [key in TDatabase]: {
    label: string;
    type: string;
  }[];
} = {
  amazonathena: [
    {
      label: 'Region',
      type: 'text',
    },
    {
      label: 'S3 Location',
      type: 'text',
    },
    {
      label: 'Access Key',
      type: 'password',
    },
    {
      label: 'Secret Key',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  redshift: [
    {
      label: 'Server Url',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  databricks: [
    {
      label: 'Server Hostname',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'HTTP Path',
      type: 'text',
    },
    {
      label: 'Token',
      type: 'text',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  bigquery: [
    {
      label: 'Token',
      type: 'text',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  db2: [
    {
      label: 'Server',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  mariadb: [
    {
      label: 'Server',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  motherduck: [
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  sqlserver: [
    {
      label: 'Server Url',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  mysql: [
    {
      label: 'Server Url',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  oracle: [
    {
      label: 'Host',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Service Name',
      type: 'text',
    },
    {
      label: 'Key Store',
      type: 'file',
    },
    {
      label: 'Key Store Password',
      type: 'password',
    },
    {
      label: 'Trust Store',
      type: 'file',
    },
    {
      label: 'Trust Store Password',
      type: 'password',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  postgresql: [
    {
      label: 'Server Url',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  snowflake: [
    {
      label: 'Server',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  saphana: [
    {
      label: 'Server',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  teradata: [
    {
      label: 'Server',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
  clickhouse: [
    {
      label: 'Server Url',
      type: 'text',
    },
    {
      label: 'Port',
      type: 'number',
    },
    {
      label: 'Database',
      type: 'text',
    },
    {
      label: 'Username',
      type: 'text',
    },
    {
      label: 'Password',
      type: 'password',
    },
    {
      label: 'Connection Name',
      type: 'text',
    },
  ],
};
export const databaseList = [
  {
    id: 1,
    value: 'amazonathena',
    name: 'Amazon Athena',
    img: athenaicon,
  },
  {
    id: 2,
    value: 'redshift',
    name: 'Amazon Redshift',
    img: redshiftIcon,
  },
  {
    id: 3,
    value: 'databricks',
    name: 'Databricks',
    img: databricksIcon,
  },
  {
    id: 4,
    value: 'bigquery',
    name: 'Google BigQuery',
    img: bigqueryicon,
  },
  {
    id: 5,
    value: 'db2',
    name: 'IBM DB2',
    img: ibmdb2icon,
  },
  {
    id: 6,
    value: 'mariadb',
    name: 'Maria DB',
    img: mariadbicon,
  },
  {
    id: 7,
    value: 'motherduck',
    name: 'Motherduck',
    img: motherduckicon,
  },
  {
    id: 8,
    value: 'sqlserver',
    name: 'MS SQL Server',
    img: mssqlicon,
  },
  {
    id: 9,
    value: 'mysql',
    name: 'MySQL',
    img: mysqlicon,
  },
  {
    id: 10,
    value: 'oracle',
    name: 'Oracle',
    img: oracleicon,
  },
  {
    id: 11,
    value: 'postgresql',
    name: 'PostgreSQL',
    img: postgresicon,
  },

  {
    id: 12,
    value: 'snowflake',
    name: 'Snowflake',
    img: snowflakeicon,
  },
  {
    id: 13,
    value: 'saphana',
    name: 'SAP HANA',
    img: saphanaicon,
  },
  {
    id: 14,
    value: 'teradata',
    name: 'Teradata',
    img: teradataicon,
  },
  {
    id: 15,
    value: 'clickhouse',
    name: 'Clickhouse',
    img: clickhouseicon,
  },
];

export const databaseImageMap = {
  amazonathena: athenaicon,
  redshift: redshiftIcon,
  databricks: databricksIcon,
  bigquery: bigqueryicon,
  db2: ibmdb2icon,
  mariadb: mariadbicon,
  motherduck: motherduckicon,
  sqlserver: mssqlicon,
  mysql: mysqlicon,
  oracle: oracleicon,
  postgresql: postgresicon,
  snowflake: snowflakeicon,
  saphana: saphanaicon,
  teradata: teradataicon,
  clickhouse: clickhouseicon,
  default: '/database_icon.svg',
};

export type ConnectionInfo = {
  vendor: TDatabase | null;
  server: string;
  port: string;
  database: string;
  username: string;
  connectionName: string;
  password: string;
  httpPath: string;
  keystore: File | null;
  keystorePassword: string;
  truststore: File | null;
  truststorePassword: string;
  region: string;
  s3Location: string;
  keystoreFileName: string;
  truststoreFileName: string;
  id: string;
};

export const initialState: ConnectionInfo = {
  id: '',
  vendor: null,
  server: '',
  port: '',
  database: '',
  username: '',
  connectionName: '',
  password: '',
  httpPath: '',
  keystore: null,
  keystorePassword: '',
  truststore: null,
  truststorePassword: '',
  region: '',
  s3Location: '',
  keystoreFileName: '',
  truststoreFileName: '',
};
export type ConnectionKey = keyof typeof initialState;
